export default "__VITE_ASSET__ChVJy7Vw__"